import { render, staticRenderFns } from "./time-card.vue?vue&type=template&id=542b90a4&scoped=true&"
import script from "./time-card.vue?vue&type=script&lang=ts&"
export * from "./time-card.vue?vue&type=script&lang=ts&"
import style0 from "./time-card.vue?vue&type=style&index=0&id=542b90a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b90a4",
  null
  
)

export default component.exports